import { useNavigate, useParams } from 'react-router-dom';
import history from '../../common/history';
import React, { useEffect, useState, useCallback } from 'react';
import styled, { keyframes } from 'styled-components';
// import QrReader from 'react-web-qr-reader';
import { QrReader } from 'react-qr-reader';
import { useGetItemByTno } from '../../../interface/item';
import { useGetInoutHistItem, useGetInoutHistSel, useGetInoutInfo, useGetInoutSel, useSetInoutHist } from '../../../interface/inout';
import NaviText from '../../backoffice/common/NaviText';
import { Row } from '../../../styles/common';
import { Drawer, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import Button from '../../common/Button';
import theme from '../../../styles/theme';
import { useGetCodeList } from '../../../interface/common';
import CommonDataGrid from '../../common/CommonDataGrid';
import MobileMsgModal from '../../common/modal/MobileMsgModal';
import { useGetInspectHistSel, useGetInspectSel, useSetInspectHist } from '../../../interface/inspect';
import useSound from 'use-sound';
import { useQuery } from 'react-query';

const MainWrap = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const QRWrapper = styled.div`
    width: calc(100% - 8rem);
    height: auto;
    section div {
        border: 0 !important;
        box-shadow: none !important;
    }


    video {
        border-radius: 25%;
    }

    border-radius: 25%;
`;

const ItemInfo = () => {

    // const delay = 500;
    const delay = 100;

    const navigate = useNavigate();
    const param = useParams();

    const { data : user } = useQuery('USER', {});
    const [result, setResult] = useState('');
    const [msg, setMsg] = useState('');
    const [sno, setSno] = useState();
    const [msgOpen, setMsgOpen] = useState(false);

    const [selectInoutList, setSelectInoutList] = useState();

    const { data: inoutList} = useGetInoutSel({is_ing:1});
    const { data: itemInfo, refetch: itemRefetch,remove} = useGetItemByTno(result);
    const { mutate } = useSetInoutHist();

    const [normal] = useSound('/sound/normal.mp3');

    // const [deviceId, setDeviceId] = useState(null);

    useEffect(()=>{
        if(result && result.tid){
            normal();
            setSno();
            itemRefetch();
        }
    },[result])

    useEffect(()=>{
        console.log(inoutList)
        setSelectInoutList(inoutList);
    },[inoutList])

    useEffect(()=>{
            if(itemInfo && itemInfo.length===0) {
                setMsg('등록되어있지 않은 자산입니다.')
            }else if(itemInfo && itemInfo.length>0){
                // console.log(inoutList,itemInfo[0])
                setSno(itemInfo[0].sno)
                if(itemInfo[0].is_ing > 0){
                    const target = inoutList.find((item)=>item.sno === itemInfo[0].sno)
                    setSelectInoutList(inoutList.filter((item)=>item.iot_tp === target.iot_tp));
                    setMsg('')
                }else{
                    setMsg('이미 완료된 작업에 속한 자산입니다.')
                }
            }
    },[itemInfo])

    // const handleDevices = useCallback(
    //     mediaDevices => {
    //         const frontCamera = mediaDevices.find(media => /front|user|selfie/i.test(media.label));
    //         if (frontCamera) {
    //             setDeviceId(frontCamera.deviceId);
    //         }
    //     }, [setDeviceId]
    // );

    // useEffect(()=>{
    //     navigator.mediaDevices.enumerateDevices().then(handleDevices);
    //   }, [handleDevices]);

    const handleScan = (sresult) => {
        // if (sresult && sresult.data) {
        //     if(sresult.data.indexOf('TAMS')>-1){
        //         const target = sresult.data.replace('TAMS','')
        //         target !== result.tid && setResult({tid:target});
        //         // setResult({tno:sresult.data});
        //     }else{
        //         setMsg('잘못된 QR CODE입니다.')
        //     }
        // }

        //20251107
        if (sresult && sresult?.text) {
            if(sresult?.text.indexOf('TAMS')>-1){
                const target = sresult?.text.replace('TAMS','');
                target !== result?.tid && setResult({tid:target});
            }else{
                setMsg('잘못된 QR CODE입니다.')
            }
        }
    };

    const handleError = (error) => {
        console.log(error);
    };

    const handleUpdate = useCallback((param,tsno) => {
        mutate(
            {mode:'PUT',...param, sno:tsno, reg_id:user.uid},
            {
                onSuccess:()=>{
                    setMsg('');
                },
                onError:(e)=>{
                    // setToggle(true);
                    setMsg('변경에 실패하였습니다.'+e.response.data.message);
                }
            }
            )
    },[mutate]);

    return (
        <React.Fragment>
            <div style={{padding: '0rem 1rem',display:'flex',alignItems:'center',justifyContent:'flex-start',gap:'8px'}}>
                <img src={`/images/ic_back_arrow.svg`} style={{width:'1.15rem'}} onClick={()=>navigate(-1)}/>
                <NaviText target={[{text:'조사변경'}]} />
            </div>
            <MainWrap>
                <QRWrapper>
                    <img src={`/images/back_qr_radar.svg`} style={{ display: 'block', position: 'absolute', width: 'calc(100% - 8rem)',zIndex:1, opacity:'0.8'}} alt='' />
                    <QrReader
                        // delay={delay}
                        // // facingMode={'environment'}
                        // // deviceId={deviceId}
                        // constraints={{ facingMode: 'environment' }}
                        // onError={handleError}
                        // onScan={handleScan}

                        //20251107
                        scanDelay={delay}
                        onResult={(result, error) => {
                            if (result) handleScan(result);
                            if (error) handleError(error);
                        }}       
                        constraints={{ facingMode: 'environment', advanced: [{ zoom: 3.0 }]  }}
                        videoStyle={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        }}            
                    />
                </QRWrapper>
                {msg && msg}
                {(itemInfo && itemInfo.length > 0) &&
                    <React.Fragment>
                        {sno && 
                            <Row style={{marginTop:'8px',width:'100%',padding:'1rem 1rem'}}>
                                <FormControl style={{width:'100%'}} size='small'>
                                    <InputLabel id='iotNm-label'>과업명</InputLabel>
                                    <Select label="과업명" labelId='iotNm-label' size='small' value={sno}>
                                        {selectInoutList && selectInoutList.map((item,index)=>{
                                            return <MenuItem 
                                                        key={index} 
                                                        value={item.sno} 
                                                        onClick={()=>setSno(item.sno)}
                                                    >
                                                        {item.iot_nm}
                                                    </MenuItem>
                                        })}
                                    </Select>
                                </FormControl>
                            </Row>
                        }
                        <Row style={{width:'100%',padding:'0rem 1rem 1rem 1rem', display:'grid',gridTemplateColumns:'1fr 1fr'}}>
                            <TextField
                                id='tno' 
                                label='자산번호' 
                                size='small' 
                                InputProps={{
                                    readOnly: true,
                                }}
                                InputLabelProps={{shrink:true}} 
                                disabled
                                value={itemInfo && itemInfo[0].tno}
                                // onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                            />
                            <TextField
                                id='lot_no' 
                                label='표기번호' 
                                size='small' 
                                InputProps={{
                                    readOnly: true,
                                }}
                                InputLabelProps={{shrink:true}} 
                                disabled
                                value={itemInfo && itemInfo[0].lot_no}
                                // onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                            />
                            <TextField
                                label='구분'
                                InputProps={{
                                    readOnly: true,
                                }}
                                InputLabelProps={{shrink:true}} 
                                size='small'
                                disabled
                                // placeholder='분류'
                                value={itemInfo && itemInfo[0].pcat_nm}
                            />
                            <TextField
                                label='분류'
                                InputProps={{
                                    readOnly: true,
                                }}
                                InputLabelProps={{shrink:true}} 
                                size='small'
                                disabled
                                // placeholder='분류'
                                value={itemInfo && itemInfo[0].cat_nm}
                            />
                            <TextField 
                                    id='model_nm' 
                                    label='모델명' 
                                    size='small' 
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    InputLabelProps={{shrink:true}} 
                                    disabled
                                    value={itemInfo && itemInfo[0].model_nm}
                                    // onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                                />
                            <Button style={{margin:0,width:'100%'}} onClick={()=>handleUpdate(itemInfo[0],sno)}>작업변경</Button>
                        </Row>
                    </React.Fragment>
                }
            </MainWrap>
        </React.Fragment>
    )

}

export default ItemInfo;